module.exports = __webpack_public_path__ + "img/7.30074c51.jpg";